
import firebase from 'firebase/compat/app';
import {LayerType} from '../enums/layer-type.enum';

export class Layer {
  id: string;
  projectId: string;
  type: LayerType;
  name = '';
  opacity = 1.0;
  storagePath: string;
  downloadUrl: string;
  placeholderUrl?: string;
  createdOn = firebase.firestore.FieldValue.serverTimestamp();
  bounds?: google.maps.LatLngBoundsLiteral;
  /**
   * Degrees the picture is turned clockwise about the middle of `bounds`, on
   * the flat map and in 3D (the 3D view's gizmo turns it). `bounds` stays
   * the picture's own box, before it is turned.
   */
  rotation?: number;
  /**
   * In 3D, metres the picture is raised or lowered over its ground: the
   * gizmo's up arrow. The iOS app's own field, and its name.
   */
  height_offset_3d?: number;
  /**
   * In 3D, whether the picture follows the ground under it (the default) or
   * lies flat at the ground of its middle. The iOS app's own field.
   */
  follows_ground_3d?: boolean;
  /** Vector layers: how many features the file holds. */
  featureCount?: number;
  blob?: Blob;
}

/** A picture's turn as CSS, about the middle of its box ('' when it is not turned). */
export function layerRotationCss(layer: Layer | null | undefined): string {
  const degrees = Number(layer?.rotation);
  return Number.isFinite(degrees) && degrees % 360 !== 0 ? `rotate(${degrees}deg)` : '';
}

/** Whether a picture follows the ground in 3D: unless it was laid flat. */
export function followsGround3d(layer: Layer | null | undefined): boolean {
  return layer?.follows_ground_3d !== false;
}

/** A picture's raise in 3D, in metres (0 for none, or not a number). */
export function heightOffset3dOf(layer: Layer | null | undefined): number {
  const offset = Number(layer?.height_offset_3d);
  return Number.isFinite(offset) ? offset : 0;
}
